module.exports = __webpack_public_path__ + "img/loading.682267a2.svg";